var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"color":"secondary"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-keyboard-return")]),_vm._v(" Regresar ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }